import Drawer from 'react-modern-drawer';
import 'react-modern-drawer/dist/index.css';
import React, { FC } from 'react';

interface Props {
  visible: boolean;
  handleClose: () => void;
  title?: React.ReactNode | string;
  children: React.ReactNode;
  hideHeader?: boolean;
}

const RightDrawer: FC<Props> = ({ visible, handleClose, title, children, hideHeader = false }) => {
  return (
    <Drawer
      open={visible}
      onClose={handleClose}
      duration={250}
      size="13.0625rem"
      direction="right"
      zIndex={2147483004}
      lockBackgroundScroll
    >
      <div className="h-[100vh]">
        {!hideHeader && (
          <nav className="flex items-center justify-between p-[16px]">
            <h3 className="font-semibold text-[#1B1F4D]">{title || ''}</h3>
            <svg
              onClick={handleClose}
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15 5L5 15"
                stroke="#1B1F4D"
                strokeWidth="1.69231"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M5 5L15 15"
                stroke="#1B1F4D"
                strokeWidth="1.69231"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </nav>
        )}
        <div className="overflow-y-auto pt-0" style={{ height: 'calc(100vh - 56px)' }}>
          {children}
        </div>
      </div>
    </Drawer>
  );
};

export default RightDrawer;
